// src/hooks/useAuthorization.ts
import { useSession } from "next-auth/react";
import { isGazelleEmail } from "@/lib/gazelle-staff";

function useAuthorization() {
  const { data: session, status } = useSession();

  const userEmail = session?.user?.email ?? null;
  const isGazelle = isGazelleEmail(userEmail);
  const canAccessRestrictedForms =
    session?.user?.canAccessRestrictedForms === true;

  return {
    isGazelle,
    canAccessRestrictedForms,
    isLoaded: status !== "loading",
    session,
    status,
  };
}

export default useAuthorization;
